exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.header-provision .cell {\n  padding: 0 2px 0 2px!important;\n}\n", ""]);

// exports
